import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import moment from "moment";
import AdminDiamondReportService from "../../services/reports-AdminDiamond-service";
import { Spin } from "antd";
import Chart from "react-google-charts";
import { chartColors } from "../reports/colors";

const AdminDiamondShapeIndComp = ({
  globalDiamonds,
  mainForDealer,
  isApplyFilter,
  pageNo,
  pageSize,
  sortOrderCol,
  sortOrderType,
  setPageNo,
  handleGetDiamondShapeList,
  colorData,
  setColorData,
  setChartData,
  chartData,
  setTableShapeValue,
  setPaginationPage,
}) => {
  const { t } = useTranslation();
  const [dealerId, setDealerId] = useState();
  const loginDetials = useSelector((state) => state.loginReducer);
  const [DiamondShapeLoading, setDiamondShapeLoading] = useState(false);

  const MAX_ENTRIES = 15;

  useEffect(() => {
    if (loginDetials?.loginDetials?.responseData?.logInSucceeded) {
      setDealerId(loginDetials.loginDetials.responseData.dealerId);
      handleDiamondChartForShape(
        loginDetials.loginDetials.responseData.dealerId,
        mainForDealer
      );
    }
  }, [isApplyFilter]);

  const processChartData = (responseData) => {
    if (!responseData?.length) return { chartData: [], colors: [] };

    const filtered = responseData.filter(item => item.CNT > 0);
    const sorted = filtered.sort((a, b) => b.CNT - a.CNT);

    const topData = sorted.slice(0, MAX_ENTRIES);
    const remaining = sorted.slice(MAX_ENTRIES);

    const othersValue = remaining.reduce((sum, item) => sum + item.CNT, 0);
    if (othersValue > 0 && remaining.length > 0) {
      topData.push({ Cut: t("Others"), CNT: othersValue, isOthers: true });
    }

    const processedChartData = [
      ["Shape", "Searches", { role: "style" }, { role: "annotation" }]
    ];
    const colors = [];

    topData.forEach((item, index) => {
      const color = chartColors[index % chartColors.length];
      colors.push(color);
      processedChartData.push([item.Cut, item.CNT, color, item.CNT]);
    });

    return { chartData: processedChartData, colors };
  };

  const handleDiamondChartForShape = (dealerId, forDealer) => {
    setDiamondShapeLoading(true);
    const inputData = {
      dealerID: dealerId.toString(),
      forDealer: forDealer ? forDealer.toString() : "",
      fromDate: globalDiamonds.dataRangeFrom
        ? moment(globalDiamonds.dataRangeFrom).format("YYYY-MM-DD")
        : "2020-08-17",
      toDate: globalDiamonds.dataRangeTo
        ? moment(globalDiamonds.dataRangeTo).format("YYYY-MM-DD")
        : "2022-09-15",
      retailerIds: globalDiamonds.retailerIds.toString(),
      vendorIds: globalDiamonds.vendorIds.toString(),
      selectedDiamondValue: globalDiamonds.SelectedDiamondValue,
      type: "Global",
      reportName: "Cut",
    };

    AdminDiamondReportService.LoadChartReports(inputData)
      .then((res) => {
        setDiamondShapeLoading(false);
        if (res.data.message === "Success" && res.data.responseData?.DiamondShapeSearches) {
          const responseData = res.data.responseData.DiamondShapeSearches;
          const { chartData: processedData, colors } = processChartData(responseData);
          setChartData(processedData);
          setColorData(colors);
        } else {
          setChartData([]);
          setColorData([]);
        }
      })
      .catch(() => {
        setDiamondShapeLoading(false);
        setChartData([]);
        setColorData([]);
      });
  };

  const handleClick = ({ chartWrapper }) => {
    const chart = chartWrapper.getChart();
    const selection = chart.getSelection();
    if (selection.length > 0) {
      const selectedItem = selection[0];
      const label = chartData[selectedItem.row + 1][0];
      // Update parent state to trigger table refresh
      if (setTableShapeValue) {
        setTableShapeValue(label);
      }
      if (setPaginationPage) {
        setPaginationPage(1);
      }
    }
  };

  const chartOptions = {
    legend: { position: "none" },
    bar: { groupWidth: "40%" },
    chartArea: { left: 40, top: 80, bottom: 70, width: "90%", height: "80%" },
    hAxis: {
      title: "Shape",
      textStyle: { fontSize: 18, bold: true, color: "#424242" },
      titleTextStyle: { color: "rgb(66, 66, 66)", fontSize: 22, bold: true },
    },
    vAxis: {
      title: "Searches",
      textStyle: { fontSize: 18, bold: true, color: "#424242" },
      titleTextStyle: { color: "rgb(66, 66, 66)", fontSize: 22, bold: true },
    },
    annotations: {
      alwaysOutside: true,
      textStyle: {
        fontSize: 16,
        bold: true,
        color: "#000",
      },
    },
  };

  return (
    <div className="">
      <Spin spinning={DiamondShapeLoading} size="large">
        {chartData.length > 1 ? (
          <div id="pdf-content">
            {/* Custom Legend */}
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                marginBottom: "10px",
              }}
            >
              {chartData.slice(1).map((row, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    margin: "0 10px",
                    fontSize: "14px",
                    fontWeight: "bold",
                  }}
                >
                  <div
                    style={{
                      width: "14px",
                      height: "14px",
                      backgroundColor: colorData[index],
                      marginRight: "6px",
                    }}
                  ></div>
                  {row[0]} ({row[1]})
                </div>
              ))}
            </div>

            <Chart
              chartType="ColumnChart"
              width={window.innerWidth > 500 ? "100%" : 300}
              height={window.innerWidth > 500 ? 750 : 300}
              data={chartData}
              options={chartOptions}
              chartEvents={[
                {
                  eventName: "select",
                  callback: handleClick,
                },
              ]}
            />
          </div>
        ) : (
          <div className="no-report-render">
            <div className="desc-space">
              <h4 className="text-center">{t("No Data Found")}</h4>
            </div>
          </div>
        )}
      </Spin>
    </div>
  );
};

export default AdminDiamondShapeIndComp;